import { zSchema, schemes, ERolloverType } from "@zeal/common";

export const getAccrualBalancesByEmployeeRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  employeeID: schemes.mongoOrUuid(),
});

export type TGetAccrualBalancesByEmployeeRequestSchema = zSchema.infer<
  typeof getAccrualBalancesByEmployeeRequestSchema
>;

export const getAccrualBalancesByEmployeeResponseSchema = zSchema.object({
  first_name: zSchema.string(),
  middle_name: zSchema.string(),
  last_name: zSchema.string(),
  work_anniversary_date: zSchema.string().nullable(),
  balances: zSchema.array(
    zSchema.object({
      policyID: schemes.mongoOrUuid(),
      policy_code: zSchema.string(),
      policy_name: zSchema.string(),
      balance_cap: zSchema.number().nullable(),
      balance: zSchema.number(),
      rollover_type: zSchema.nativeEnum(ERolloverType),
    })
  ),
});

export type TGetAccrualBalancesByEmployeeResponseSchema = zSchema.infer<
  typeof getAccrualBalancesByEmployeeResponseSchema
>;
